enum EFetchStatus {
  LOADING = 'loading',
  WAITING = 'waiting',
  SUCCESS = 'success',
  ERROR = 'error',
}

export default EFetchStatus
